<template>
  <div class="login-panel" v-loading="authLoginLoading">
    <div class="login-change-corner" v-if="businessType === 'login' && loginType !== 'wx'">
      <div class="triangle-mask"></div>
      <div
        class="icon-box icon-code"
        @click="loginTypeChange('scan')"
        v-if="loginType === 'normal'"
      ></div>
      <div
        class="icon-box icon-pwd"
        @click="loginTypeChange('normal')"
        v-if="loginType === 'scan'"
      ></div>
    </div>

    <login-panel-normal v-if="loginType === 'normal'" />
    <login-panel-scan v-else />

    <div class="bottom-bar" v-if="businessType === 'login'">
      <div class="others-login" v-if="loginType !== 'wx'">
        <div>其它登录方式：</div>
        <div class="wx-login" @click="getWxAuthUrl"></div>
      </div>
      <div
        class="forget-pwd"
        v-if="loginType === 'normal' && tabActive === 'password'"
        @click="changeBusinessType"
      >
        忘记密码
      </div>
    </div>
    <div v-else class="go-login" @click="changeBusinessType">返回至登录页</div>
  </div>
</template>

<script >
import LoginPanelNormal from './login-panel-normal.vue';
import LoginPanelScan from './login-panel-scan.vue';
import { provide, inject, ref, onMounted } from '@vue/composition-api';
import { useAuthLogin } from '@/views/login/hooks/useAuthLogin.js';

// 业务类型 login forgetPwd
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const businessType = inject('businessType');

  // 忘记密码
  const changeBusinessType = () => {
    businessType.value = businessType.value === 'login' ? 'forgetPwd' : 'login';
  };

  // 切换登录方式 login 账号密码登录、手机验证码登录   scan 扫码登录   wx  微信授权登录
  const loginType = ref('normal');
  provide('loginType', loginType);
  const loginTypeChange = type => {
    loginType.value = type;
  };
  const tabActive = ref('password');
  provide('tabActive', tabActive);
  const {
    authLoginLoading,
    getWxAuthUrl,
    wxAuthLogin,
    handleBind
  } = useAuthLogin({
    socialCallback: loginTypeChange
  });
  provide('handleBind', handleBind);
  onMounted(() => {
    wxAuthLogin();
  });
  return {
    businessType,
    changeBusinessType,
    loginType,
    loginTypeChange,
    tabActive,
    authLoginLoading,
    getWxAuthUrl
  };
};
__sfc_main.components = Object.assign({
  LoginPanelNormal,
  LoginPanelScan
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .login-panel {
    position: relative;
    width: 500px;
    height: 558px;
    box-sizing: border-box;
    padding: 85px 52px 64px;
    overflow: hidden;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 13.8px 0px rgba(0, 0, 0, 0.15);
  }

  .login-change-corner {
    z-index: 1;
    background-color: #f3f4f6;
    position: absolute;
    top: 0;
    right: 0;
    width: 85px;
    height: 85px;
    overflow: hidden;
    .triangle-mask {
      z-index: 2;
      background-color: #ffffff;
      position: absolute;
      top: 0;
      right: 35px;
      width: 170px;
      height: 170px;
      transform: rotate(45deg);
      transform-origin: center;
    }
    .icon-box {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .icon-code {
      z-index: 1;
      background: url('../../../static/login/icon-code.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon-pwd {
      z-index: 1;
      background: url('../../../static/login/icon-pwd.png') no-repeat;
      background-size: 100% 100%;
    }
  }

  .bottom-bar {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .others-login {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
    }
    .wx-login {
      cursor: pointer;
      width: 29px;
      height: 29px;
      background: url('../../../static/login/wx-login.png') no-repeat;
      background-size: 100% 100%;
    }
    .forget-pwd {
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: #22c655;
    }
  }

  .go-login {
    cursor: pointer;
    margin-top: 29px;
    font-size: 16px;
    font-weight: 500;
    color: #22c655;
    text-align: center;
  }
</style>
